export class InvalidThemeNameError extends Error {
  constructor(invalidThemeName: string) {
    super(`Invalid theme name ${invalidThemeName}`);
  }
};
